module.exports = function isBuffer(arg) {
  return arg && typeof arg === 'object'
    && typeof arg.copy === 'function'
    && typeof arg.fill === 'function'
    && typeof arg.readUInt8 === 'function';
}


//////////////////
// WEBPACK FOOTER
// /Users/mthuret/Code/work/react-instantsearch/~/util/support/isBufferBrowser.js
// module id = 239
// module chunks = 0 1